export class EmailNewOrgAdd {
    firstName: string;
    lastName: string;
    email: string;
    organizationName: string;
    instanceName?: string;
    password?: string;
}
